<template>
  <div
    :class="navigation || culturePop ? 'popup' : '' || startProjectPop || recruitPop ? 'popup black' : '' || awardsPop ? 'black-gra' : ''"
    class="container viewPage jklView"
  >
    <header-area />

    <div class="worksView">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan">
              Design guide to advance
              <br>the credibility of the Firm
            </div>
            <div class="workTopDay">
              <p>JKL PARTNERS 웹사이트개편</p>
              <ul>
                <li>Web site</li>
                <li>2019.12.03</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a
                href="http://www.jklpartners.co.kr"
                target="_blank"
                class="siteAddr"
              >http://www.jklpartners.co.kr</a>
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/tigeretf"
                    title="상상하는 모든 주제가 투자 대상이 된다 미래에셋 TIGER ETF 웹사이트"
                    hashtags="플립커뮤니케이션즈,미래에셋,TIGER_ETF"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a
                        href="javascript:;"
                        class="wFacebook"
                      >
                        <img
                          src="@/assets/images/@sns_fb_w.png"
                          alt=""
                        >
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/tigeretf"
                    title="상상하는 모든 주제가 투자 대상이 된다 미래에셋 TIGER ETF 웹사이트"
                    hashtags="플립커뮤니케이션즈,미래에셋,TIGER_ETF"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a
                        href="javascript:;"
                        class="wTweeter"
                      >
                        <img
                          src="@/assets/images/@sns_tw_w.png"
                          alt=""
                        >
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a
                    href="javascript:;"
                    @click.prevent="doCopy"
                    class="wChain"
                  >
                    <img
                      src="@/assets/images/@web_link_w.png"
                      alt=""
                    >
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"><marquee-text :duration="9">&nbsp;JKL Partners JKL Partners JKL Partners</marquee-text></span>
          <img
            src="@/assets/images/works_view/jkl/jkl_visual.jpg"
            alt=""
          >
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          JKL PARTNERS는 국내 대표 Private Equity 운용사입니다. 노후화 된 페이지의 사용성 개선과 세련되고 신뢰감 있는 대외 이미지 제고를 위한 구축을 목적으로 리뉴얼을 진행하였습니다. 마이크로 인터랙션과 패럴럭스 스크롤 등 요소들을 접목시켜 앞서가는 트렌디한 기업의 이미지 제고하고, 사용자를 위한 인터페이스 구성과 JKL만의 느낌으로 재구성한 톤앤매너로 기업의 신뢰감을 줄 수 있는 디자인 가이드를 완성하였습니다.
        </div>
      </div>
    </div>

    <div class="wideConts">
      <!-- section_1 -->
      <div class="jklSection1">
        <div class="worksView">
          <div class="contsBox">
            <div class="topDiagram">
              <div class="diag1">
                <div class="diagStart">
                  <span>신뢰</span>
                </div>
                <div class="diagList">
                  <span class="diagLine">
                    <span />
                  </span>
                  <ul>
                    <li class="diagLi1">
                      <div class="diagIn">
                        <span>Identity Color</span>
                      </div>
                    </li>
                    <li class="diagLi2">
                      <div class="diagIn">
                        <span>Serif<br>Headline</span>
                      </div>
                    </li>
                    <li class="diagLi3">
                      <div class="diagIn">
                        <span>Frame</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="diagEnd">
                  <span>Design Element</span>
                </div>
              </div>

              <div class="diag2">
                <div class="diagStart">
                  <span>세련</span>
                </div>
                <div class="diagList">
                  <span class="diagLine">
                    <span />
                  </span>
                  <ul>
                    <li class="diagLi1">
                      <div class="diagIn">
                        <span>Micro<br>Interaction</span>
                      </div>
                    </li>
                    <li class="diagLi2">
                      <div class="diagIn">
                        <span>Wide margin<br>Conposition</span>
                      </div>
                    </li>
                    <li class="diagLi3">
                      <div class="diagIn">
                        <span>Parallax<br>Scrolling</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="diagEnd">
                  <span>Design Trend</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //section_1 -->

      <!-- section_2 -->
      <div class="jklSection2">
        <div class="respUI">
          <div class="worksView">
            <div class="contsBox">
              <strong class="sectTitle short">Responsive UI</strong>
            </div>

            <div class="respUIBox">
              <div class="respWeb">
                <!-- UI 웹 -->
                <div class="scrollArea">
                  <div class="outskirts">
                    <div class="jklLogo">
                      <img
                        src="@/assets/images/works_view/jkl/jkl_logo.png"
                        alt=""
                      >
                    </div>
                    <div class="jklMenu">
                      <img
                        src="@/assets/images/works_view/jkl/jkl_menu.png"
                        alt=""
                      >
                    </div>
                    <div class="rotateTxt">
                      <img
                        src="@/assets/images/works_view/jkl/resp_rotate1.png"
                        alt=""
                      >
                      <!--
                                        <img
                                          src="@/assets/images/works_view/jkl/resp_rotate2.png"
                                          alt=""
                                        >
                                        -->
                    </div>
                    <div class="scrLine">
                      <img
                        src="@/assets/images/works_view/jkl/scroll_line1.png"
                        alt=""
                      >
                      <!--
                                        <img
                                          src="@/assets/images/works_view/jkl/scroll_line2.png"
                                          alt=""
                                        >
                                        -->
                    </div>
                    <div class="scrNextTxt">
                      <span>
                        <img
                          src="@/assets/images/works_view/jkl/scroll_next1.png"
                          alt=""
                        >
                        <!--
                                            <img
                                              src="@/assets/images/works_view/jkl/scroll_next2.png"
                                              alt=""
                                            >
                                            -->
                      </span>
                    </div>
                  </div>

                  <div class="innerBox">
                    <ul>
                      <li class="inImg1">
                        <div class="respText">
                          <div class="respTtop">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_top1.png"
                              alt=""
                            >
                          </div>
                          <p class="respParaG">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_big1.png"
                              alt=""
                            >
                          </p>
                          <span class="icobtnPlus">
                            <img
                              src="@/assets/images/works_view/jkl/ico_btn_plus.png"
                              alt=""
                            >
                          </span>
                        </div>
                      </li>
                      <li class="inImg2">
                        <div class="respText">
                          <div class="respTtop">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_top2.png"
                              alt=""
                            >
                          </div>
                          <p class="respParaG">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_big2.png"
                              alt=""
                            >
                          </p>
                          <span class="icobtnPlus">
                            <img
                              src="@/assets/images/works_view/jkl/ico_btn_plus.png"
                              alt=""
                            >
                          </span>
                        </div>
                      </li>
                    </ul>

                    <div class="icoMouse">
                      <div class="wheel" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="respMobile">
                <!-- UI 모바일 -->
                <div class="scrollArea">
                  <div class="outskirts">
                    <div class="jklLogo">
                      <img
                        src="@/assets/images/works_view/jkl/jkl_logo.png"
                        alt=""
                      >
                    </div>
                    <div class="jklMenu">
                      <img
                        src="@/assets/images/works_view/jkl/jkl_menu.png"
                        alt=""
                      >
                    </div>
                    <div class="scrNextTxt">
                      <img
                        src="@/assets/images/works_view/jkl/scroll_next1.png"
                        alt=""
                      >
                      <!--
                                        <img
                                          src="@/assets/images/works_view/jkl/scroll_next2.png"
                                          alt=""
                                        >
                                        -->
                    </div>
                  </div>

                  <div class="innerBox">
                    <ul>
                      <li class="inImg1">
                        <div class="respText">
                          <div class="respTtop">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_top1.png"
                              alt=""
                            >
                          </div>
                          <p class="respParaG">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_small1.png"
                              alt=""
                            >
                          </p>
                          <span class="icobtnPlus">
                            <img
                              src="@/assets/images/works_view/jkl/ico_btn_plus.png"
                              alt=""
                            >
                          </span>
                        </div>
                      </li>
                      <li class="inImg2">
                        <div class="respText">
                          <div class="respTtop">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_top2.png"
                              alt=""
                            >
                          </div>
                          <p class="respParaG">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_small2.png"
                              alt=""
                            >
                          </p>
                          <span class="icobtnPlus">
                            <img
                              src="@/assets/images/works_view/jkl/ico_btn_plus.png"
                              alt=""
                            >
                          </span>
                        </div>
                      </li>
                    </ul>

                    <div class="icoMouse">
                      <div class="wheel" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="respTablet">
                <!-- UI 테블릿 -->
                <div class="scrollArea">
                  <div class="outskirts">
                    <div class="jklLogo">
                      <img
                        src="@/assets/images/works_view/jkl/jkl_logo.png"
                        alt=""
                      >
                    </div>
                    <div class="jklMenu">
                      <img
                        src="@/assets/images/works_view/jkl/jkl_menu.png"
                        alt=""
                      >
                    </div>
                    <div class="rotateTxt">
                      <img
                        src="@/assets/images/works_view/jkl/resp_rotate1.png"
                        alt=""
                      >
                      <!--
                                        <img
                                          src="@/assets/images/works_view/jkl/resp_rotate2.png"
                                          alt=""
                                        >
                                        -->
                    </div>
                    <div class="scrLine">
                      <img
                        src="@/assets/images/works_view/jkl/scroll_line1.png"
                        alt=""
                      >
                      <!--
                                        <img
                                          src="@/assets/images/works_view/jkl/scroll_line2.png"
                                          alt=""
                                        >
                                        -->
                    </div>
                    <div class="scrNextTxt">
                      <img
                        src="@/assets/images/works_view/jkl/scroll_next1.png"
                        alt=""
                      >
                      <!--
                                        <img
                                          src="@/assets/images/works_view/jkl/scroll_next2.png"
                                          alt=""
                                        >
                                        -->
                    </div>
                  </div>

                  <div class="innerBox">
                    <ul>
                      <li class="inImg1">
                        <div class="respText">
                          <div class="respTtop">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_top1.png"
                              alt=""
                            >
                          </div>
                          <p class="respParaG">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_small1.png"
                              alt=""
                            >
                          </p>
                          <span class="icobtnPlus">
                            <img
                              src="@/assets/images/works_view/jkl/ico_btn_plus.png"
                              alt=""
                            >
                          </span>
                        </div>
                      </li>
                      <li class="inImg2">
                        <div class="respText">
                          <div class="respTtop">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_top2.png"
                              alt=""
                            >
                          </div>
                          <p class="respParaG">
                            <img
                              src="@/assets/images/works_view/jkl/resp_text_small2.png"
                              alt=""
                            >
                          </p>
                          <span class="icobtnPlus">
                            <img
                              src="@/assets/images/works_view/jkl/ico_btn_plus.png"
                              alt=""
                            >
                          </span>
                        </div>
                      </li>
                    </ul>

                    <div class="icoMouse">
                      <div class="wheel" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="gAndF">
          <div class="worksView">
            <div class="contsBox">
              <strong class="sectTitle short">Grid & Frame</strong>
            </div>

            <div class="gAndFBg" />
          </div>
        </div>
      </div>
      <!-- //section_2 -->

      <!-- section_3 -->
      <div class="jklSection3">
        <div class="fixAndPlx">
          <div class="worksView">
            <div class="contsBox">
              <strong class="sectTitle">Fixed navigation & Parallax Scrolling</strong>
            </div>

            <div class="subMotArea">
              <div class="subMotBox on">
                <!-- 클래스 subMotBox옆에 on을 빼면 이미지가 transition으로 움직임 -->
                <div class="fAndPtop">
                  <img
                    src="@/assets/images/works_view/jkl/f_and_p_top.jpg"
                    alt=""
                  >
                </div>

                <div class="subMotImg">
                  <div class="fAndPtxt">
                    <span>
                      <img
                        src="@/assets/images/works_view/jkl/f_and_p_text.png"
                        alt=""
                      >
                    </span>
                  </div>

                  <div class="fAndPMouse">
                    <div class="wheel" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wideMC">
          <div class="worksView">
            <div class="contsBox">
              <strong class="sectTitle">Wide margin Conposition</strong>
            </div>

            <div class="wideMCArea">
              <div class="wideMcMoblie">
                <div class="wideMcMInner">
                  <div class="teamTop">
                    <div class="teamMmenu">
                      <img
                        src="@/assets/images/works_view/jkl/team_m_top.jpg"
                        alt=""
                      >
                    </div>
                    <div class="teamMtxt">
                      <p>
                        <img
                          src="@/assets/images/works_view/jkl/team.png"
                          alt=""
                        >
                      </p>
                      <span>
                        <img
                          src="@/assets/images/works_view/jkl/team_text_mobile.png"
                          alt=""
                        >
                      </span>
                    </div>
                  </div>

                  <div class="wideMcMoSlider swiper-container">
                    <ul class="swiper-wrapper">
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail1.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail2.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail3.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail4.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail5.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail6.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail7.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail8.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail9.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail10.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail11.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail12.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail13.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail14.jpg"
                          alt=""
                        >
                      </li>
                    </ul>
                  </div>

                  <div class="teamBtm">
                    <div class="allAndSea">
                      <div class="teamAll">
                        <div>
                          <img
                            src="@/assets/images/works_view/jkl/team_all.png"
                            alt=""
                          >
                        </div>
                      </div>
                      <div class="teamSea">
                        <div>
                          <img
                            src="@/assets/images/works_view/jkl/ico_search.jpg"
                            alt=""
                          >
                        </div>
                      </div>
                    </div>
                    <div class="ByAndPosit">
                      <ul>
                        <li class="teamBy">
                          <div>
                            <img
                              src="@/assets/images/works_view/jkl/team_by.png"
                              alt=""
                            >
                          </div>
                        </li>
                        <li class="teamPosit">
                          <div>
                            <img
                              src="@/assets/images/works_view/jkl/team_position.png"
                              alt=""
                            >
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wideMcWeb">
                <div class="wideMcWeInner">
                  <div class="teamWTop">
                    <div class="teamWmenu">
                      <img
                        src="@/assets/images/works_view/jkl/team_w_top.jpg"
                        alt=""
                      >
                    </div>
                    <div class="teamWtxt">
                      <p>
                        <img
                          src="@/assets/images/works_view/jkl/team.png"
                          alt=""
                        >
                      </p>
                      <span>
                        <img
                          src="@/assets/images/works_view/jkl/team_text_web.png"
                          alt=""
                        >
                      </span>
                    </div>
                  </div>

                  <div class="wideMcWebSlider swiper-container">
                    <ul class="swiper-wrapper">
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail1.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail2.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail3.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail4.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail5.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail6.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail7.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail8.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail9.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail10.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail11.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail12.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail13.jpg"
                          alt=""
                        >
                      </li>
                      <li class="swiper-slide">
                        <img
                          src="@/assets/images/works_view/jkl/thumnail14.jpg"
                          alt=""
                        >
                      </li>
                    </ul>
                  </div>

                  <div class="teamWBtm">
                    <div class="teamRT">
                      <img
                        src="@/assets/images/works_view/jkl/team_r_t.jpg"
                        alt=""
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //section_3 -->

      <!-- section_4 -->
      <div class="jklSection4">
        <div class="mofocusD">
          <div class="worksView">
            <div class="contsBox">
              <strong class="sectTitle">Mobile focus Design</strong>
            </div>

            <div class="mfDArea swiper-container">
              <ul class="swiper-wrapper">
                <li class="firstMfDLi swiper-slide">
                  <div class="mfAll">
                    <div class="mfTop">
                      <img
                        src="@/assets/images/works_view/jkl/mofocusd_top.jpg"
                        alt=""
                      >
                    </div>

                    <div class="mfScr">
                      <ul>
                        <li class="mFinImg1">
                          <p>
                            <img
                              src="@/assets/images/works_view/jkl/mfd_strategy.png"
                              alt=""
                            >
                          </p>
                          <div class="icoMouseMf">
                            <div class="wheel" />
                          </div>
                        </li>
                        <li class="mFinImg2 firstMf">
                          <div class="mfInTitle">
                            <strong>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_1_title.png"
                                alt=""
                              >
                            </strong>
                            <span>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_1_txt.png"
                                alt=""
                              >
                            </span>
                          </div>
                          <ul>
                            <li>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_1_con1.png"
                                alt=""
                              >
                            </li>
                            <li>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_1_con2.png"
                                alt=""
                              >
                            </li>
                            <li>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_1_con3.png"
                                alt=""
                              >
                            </li>
                            <li>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_1_con4.png"
                                alt=""
                              >
                            </li>
                            <li>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_1_con5.png"
                                alt=""
                              >
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <li class="secondMfDLi swiper-slide">
                  <div class="mfAll">
                    <div class="mfTop">
                      <img
                        src="@/assets/images/works_view/jkl/mofocusd_top.jpg"
                        alt=""
                      >
                    </div>

                    <div class="mfScr">
                      <ul>
                        <li class="mFinImg1">
                          <p>
                            <img
                              src="@/assets/images/works_view/jkl/mfd_team.png"
                              alt=""
                            >
                          </p>
                          <div class="icoMouseMf">
                            <div class="wheel" />
                          </div>
                        </li>
                        <li class="mFinImg2 secondMf">
                          <div class="mfInTitle">
                            <strong>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_2_title.png"
                                alt=""
                              >
                            </strong>
                            <span>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_2_txt.png"
                                alt=""
                              >
                            </span>
                          </div>
                          <div class="mfInthum">
                            <div>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_2_thum.png"
                                alt=""
                              >
                            </div>
                          </div>
                          <div class="mfInInp">
                            <ul>
                              <li>
                                <div class="mfInInpL">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_inp1.png"
                                    alt=""
                                  >
                                </div>
                                <div class="mfInInpR">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_inp2.png"
                                    alt=""
                                  >
                                </div>
                              </li>
                              <li>
                                <img
                                  src="@/assets/images/works_view/jkl/mfd_in_2_inp3.png"
                                  alt=""
                                >
                              </li>
                              <li>
                                <img
                                  src="@/assets/images/works_view/jkl/mfd_in_2_inp4.png"
                                  alt=""
                                >
                              </li>
                            </ul>
                          </div>
                          <div class="mfInPp">
                            <ul>
                              <li>
                                <div class="mfInPpPot">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp1.jpg"
                                    alt=""
                                  >
                                </div>
                                <div class="mfInPpNam">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp1_name.png"
                                    alt=""
                                  >
                                </div>
                                <div class="mfInPpTxt">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp1_info.png"
                                    alt=""
                                  >
                                </div>
                              </li>
                              <li>
                                <div class="mfInPpPot">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp2.jpg"
                                    alt=""
                                  >
                                </div>
                                <div class="mfInPpNam">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp2_name.png"
                                    alt=""
                                  >
                                </div>
                              </li>
                              <li>
                                <div class="mfInPpPot">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp3.jpg"
                                    alt=""
                                  >
                                </div>
                                <div class="mfInPpNam">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp3_name.png"
                                    alt=""
                                  >
                                </div>
                              </li>
                              <li>
                                <div class="mfInPpPot">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp4.jpg"
                                    alt=""
                                  >
                                </div>
                                <div class="mfInPpNam">
                                  <img
                                    src="@/assets/images/works_view/jkl/mfd_in_2_pp4_name.png"
                                    alt=""
                                  >
                                </div>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <li class="thirdMfDLi swiper-slide">
                  <div class="mfAll">
                    <div class="mfTop">
                      <img
                        src="@/assets/images/works_view/jkl/mofocusd_top.jpg"
                        alt=""
                      >
                    </div>

                    <div class="mfScr">
                      <ul>
                        <li class="mFinImg1">
                          <p>
                            <img
                              src="@/assets/images/works_view/jkl/mfd_stewardship.png"
                              alt=""
                            >
                          </p>
                          <div class="icoMouseMf">
                            <div class="wheel" />
                          </div>
                        </li>
                        <li class="mFinImg2 thirdMf">
                          <div class="mfInTitle">
                            <strong>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_3_title.png"
                                alt=""
                              >
                            </strong>
                            <span>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_3_txt.png"
                                alt=""
                              >
                            </span>
                          </div>
                          <div class="mfInScTxt">
                            <p>
                              <img
                                src="@/assets/images/works_view/jkl/mfd_in_3_con1.png"
                                alt=""
                              >
                            </p>
                            <div>
                              <p class="scTxtinF">
                                <img
                                  src="@/assets/images/works_view/jkl/mfd_in_3_con2.png"
                                  alt=""
                                >
                              </p>
                              <p>
                                <img
                                  src="@/assets/images/works_view/jkl/mfd_in_3_con3.png"
                                  alt=""
                                >
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- //section_4 -->
    </div>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link
            :to="{ name: 'works' }"
            class="backBtn"
          >
            <img
              src="@/assets/images/@ico_back_x2.jpg"
              alt=""
            >
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <a
        href="/works/jejuY"
        class="longEnd vType"
      >
        <div class="viewType">
          <span>next</span>
          <strong class="web">오리온 제주용암수</strong>
          <strong class="mobile">오리온<br>제주용암수</strong>
        </div>

        <div class="engBg jklEndBg">
          <span />
        </div>
      </a>
    </div>

    <footer-area />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HeaderArea from '@/components/Header'
import FooterArea from '@/components/Footer'
import common from '@/shared/mixin/common.js'
import MarqueeText from 'vue-marquee-text-component'

export default {
  mixins: [common],
  name: 'Main',
  head: {
    title: {
      inner: 'JKL PARTNERS'
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data () {
    return {
      teamMobileSlider: null,
      teamWebSlider: null,
      mfDSlider: null
    }
  },
  computed: {
    ...mapState('common', {
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    })
  },
  methods: {
    doCopy () {
      this.$copyText('https://www.pulip.com/sns/jkl').then(function (e) {
        alert('복사되었습니다.')
        console.log(e)
      }, function (e) {
        console.log(e)
      })
    }
  },
  mounted () {
    this.teamMobileSlider = new window.Swiper('.wideMcMoSlider.swiper-container', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 'auto',
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 800,
        disableOnInteraction: false
      },
      breakpoints: {
        320: {
          spaceBetween: 10
        },
        769: {
          spaceBetween: 15
        }
      }
    })
    this.teamWebSlider = new window.Swiper('.wideMcWebSlider.swiper-container', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 'auto',
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 800,
        disableOnInteraction: false
      },
      breakpoints: {
        1367: {
          spaceBetween: 30
        },
        1024: {
          spaceBetween: 25
        },
        1: {
          spaceBetween: 15
        }
      }
    })
    this.mfDSlider = new window.Swiper('.mfDArea.swiper-container', {
      pagination: {
        el: '.swiper-pagination'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        1920: {
          slidesPerView: 3,
          spaceBetween: 86,
          touchRatio: 0
        },
        1367: {
          slidesPerView: 3,
          spaceBetween: 75,
          touchRatio: 0
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 63,
          touchRatio: 0
        },
        891: {
          slidesPerView: 3,
          spaceBetween: 20,
          touchRatio: 0
        },
        1: {
          slidesPerView: 1,
          spaceBetween: 15,
          touchRatio: 1
        }
      }
    })
  },
  destroyed () {
    this.teamMobileSlider.destroy()
    this.teamWebSlider.destroy()
    this.mfDSlider.destroy()
  }
}
</script>
